import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";
import {ReactiveFormsModule} from "@angular/forms";
import {MyJournalScreenComponent} from './screen/my-journal-screen/my-journal-screen.component';
import {reducer} from "./core/my-journal.reducer";
import {StoreModule} from "@ngrx/store";
import {MyJournalEffect} from "./core/my-journal.effects";
import {EffectsModule} from "@ngrx/effects";
import {WeeksHeadingComponent} from "./components/weeks-heading/weeks-heading.component";
import {WeekListToggleComponent} from "./components/week-list-toggle/week-list-toggle.component";
import {DailyMealDrinkTrackerComponent} from './components/daily-meal-drink-tracker/daily-meal-drink-tracker.component';
import {
  DailyPhysicalActivityTrackerComponent
} from './components/daily-physical-activity-tracker/daily-physical-activity-tracker.component';
import {ScreenTimeTrackerComponent} from './components/screen-time-tracker/screen-time-tracker.component';
import {AddDailyMealComponent} from './components/add-daily-meal/add-daily-meal.component';
import {
  AddDailyPhysicalActivityComponent
} from './components/add-daily-physical-activity/add-daily-physical-activity.component';
import {AddDailyScreenTimeComponent} from './components/add-daily-screen-time/add-daily-screen-time.component';
import {TimeConversionPipe} from './pipe/time-conversion.pipe';
import {InfiniteScrollModule} from "ngx-infinite-scroll";

@NgModule({
  declarations: [
    MyJournalScreenComponent,
    WeeksHeadingComponent,
    WeekListToggleComponent,
    DailyMealDrinkTrackerComponent,
    DailyPhysicalActivityTrackerComponent,
    ScreenTimeTrackerComponent,
    AddDailyMealComponent,
    AddDailyPhysicalActivityComponent,
    AddDailyScreenTimeComponent,
    TimeConversionPipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule,
    StoreModule.forFeature('ss-cord.my-journal', reducer),
    EffectsModule.forFeature(
      [MyJournalEffect],
    ),
    InfiniteScrollModule
  ],
  providers: []
})
export class MyJournalModule {
}
